import React from "react";
import { Col, Container, Card, Row, CardBody } from "reactstrap";
import { Link } from "react-router-dom";

import Blo1Image from "../assets/images/blog/1.jpg";
import Blo2Image from "../assets/images/blog/2.jpg";
import Blo3Image from "../assets/images/blog/3.jpg";

export default function News() {
    return (
        <section className="section bg-light" id="blog">
            <Container>
                <Row className="justify-content-center">
                    <Col>
                        <div className="section-title text-center mb-4 pb-2">
                            <h4 className="title mb-3">Actualités du Syndic</h4>
                            <p className="text-muted para-desc mb-0 mx-auto">
                                Restez informé des dernières nouveautés, conseils de gestion et annonces importantes concernant votre résidence.
                            </p>
                        </div>
                    </Col>
                </Row>

                <Row>
                    <Col lg={4} md={6} className="mt-4 pt-2">
                        <Card className="blog blog-primary shadow rounded overflow-hidden border-0">
                            <div className="blog-image position-relative overflow-hidden">
                                <img src={Blo1Image} className="img-fluid" alt="Conseils de gestion" />
                            </div>
                            <CardBody className="content p-0">
                                <div className="p-4">
                                    <Link to="#" className="h5 title text-dark d-block mb-0">Optimiser la gestion des charges de copropriété</Link>
                                    <p className="text-muted mt-2 mb-0">Découvrez comment répartir efficacement les charges pour une meilleure transparence entre copropriétaires.</p>
                                    <div className="mt-3">
                                        {/* <Link to="#" className="link text-dark">Lire plus <i className="uil uil-arrow-right"></i></Link> */}
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>

                    <Col lg={4} md={6} className="mt-4 pt-2">
                        <Card className="blog blog-primary shadow rounded overflow-hidden border-0">
                            <div className="blog-image position-relative overflow-hidden">
                                <img src={Blo2Image} className="img-fluid" alt="Règlements internes" />
                            </div>
                            <CardBody className="content p-0">
                                <div className="p-4">
                                    <Link to="#" className="h5 title text-dark d-block mb-0">Nouveaux règlements pour les espaces communs</Link>
                                    <p className="text-muted mt-2 mb-0">Mise à jour importante sur l'utilisation des jardins, parkings et salles communes.</p>
                                    <div className="mt-3">
                                        {/* <Link to="#" className="link text-dark">Lire plus <i className="uil uil-arrow-right"></i></Link> */}
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>

                    <Col lg={4} md={6} className="mt-4 pt-2">
                        <Card className="blog blog-primary shadow rounded overflow-hidden border-0">
                            <div className="blog-image position-relative overflow-hidden">
                                <img src={Blo3Image} className="img-fluid" alt="Travaux planifiés" />
                            </div>
                            <CardBody className="content p-0">
                                <div className="p-4">
                                    <Link to="#" className="h5 title text-dark d-block mb-0">Planning des travaux d’entretien 2025</Link>
                                    <p className="text-muted mt-2 mb-0">Consultez les prochaines interventions prévues dans votre immeuble ou résidence.</p>
                                    <div className="mt-3">
                                        {/* <Link to="#" className="link text-dark">Lire plus <i className="uil uil-arrow-right"></i></Link> */}
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}
